export default __webpack_public_path__ + "static/media/playMarket.13a17839.png";